module.exports = __webpack_public_path__ + "media/serum-pack-small.1a0da4fd.mp4";